(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .controller('AuthController', AuthController);

    AuthController.$inject = ['$state', 'toastHelper', 'Authenticate', 'localStorageService', 'AuthService', 'UserService'];

    /* @ngInject */
    function AuthController($state, toastHelper,  Authenticate, localStorageService, AuthService, UserService) {
        var vm = this;
        vm.model = {
            login: '',
            password: ''
        };
        var toastPosition = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };

        vm.signIn = signIn;

        activate();

        ////////////////

        function activate() {
        }

        function signIn() {
            if (vm.model.login == '' || vm.model.password == '') {
                toastHelper.show('Не задан логин или пароль!');
                return;
            }
            Authenticate.save({email: vm.model.login, password: vm.model.password})
                .$promise
                .then(function(response) {
                    localStorageService.set('token', response.token);
                    UserService.loadUser(AuthService.getUserId());
                    $state.go('project');
                }, function(response) {
                    vm.model.password = '';
                    toastHelper.show('Не верно указан логин или пароль!');
                });
        }
    }

})();

